import { cn, getInitials } from '@/lib/utils'

const PALETTES = [
  'bg-primary-700 text-cream',
  'bg-accent-500 text-cream',
  'bg-emerald-700 text-cream',
  'bg-rose-600 text-cream',
  'bg-sky-700 text-cream',
  'bg-violet-700 text-cream',
  'bg-amber-600 text-cream',
]

function hashIndex(str = '') {
  let h = 0
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) & 0xffffffff
  return Math.abs(h) % PALETTES.length
}

export function PatientAvatar({ name, id, size = 'md', className }) {
  const palette = PALETTES[hashIndex(id || name || '')]
  const sizes = {
    sm: 'h-8 w-8 text-[10px]',
    md: 'h-10 w-10 text-xs',
    lg: 'h-12 w-12 text-sm',
    xl: 'h-16 w-16 text-base',
  }
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-xl font-bold tracking-wide shadow-soft',
        sizes[size] || sizes.md,
        palette,
        className,
      )}
    >
      {getInitials(name) || '—'}
    </div>
  )
}
